<div class="container">
  <div class="wrapper">
    <button type="button" class="btn-back" fill="clear" (click)="goBack()">
      <ion-icon name="arrow-back-outline"></ion-icon>
      <span>Volver</span>
    </button>

    <div style="max-width: 500px; margin: 0 20px 20px 0">
      <div class="title-section title">
        <ion-icon class="item-icono" name="alert-circle"></ion-icon>
        No cumples los requisitos del trámite
      </div>

      <div class="item-text">
        <ion-text class="div-text" style="margin-bottom: 40px">
          Está solicitud es por el tramite de pensión por vejez normal, para empleados del sector
          privado, la cual no contempla hijos, bonos y empleados del sector público. Es probable que
          no cumplas con uno de estos requisitos o debas actualizar tu información personal.
        </ion-text>

        <p class="sub-title">¿Que viene ahora?</p>
        <ion-text class="div-text">
          Podrás agendar una video atención con uno de nuestros especialistas para poder resolverlo.
        </ion-text>
      </div>
    </div>

    <div>
      <button class="primary-button" (click)="goToVideoAtencion()">Agendar video atención</button>
    </div>
  </div>
</div>
